module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Francis-Hanging-Salmon-Web-640.04a9c2dc.jpg";